import AsideStackPanel from './asideStackPanel';
import { Tab } from 'bootstrap';

class AsideTab extends AsideStackPanel
{
    constructor(options) {
        super(options);
    }

    get tabEl() { return document.getElementById(this.options.tabId); }

    isOpen = ko.observable(false);

    showTab = id => {
        let triggerEl = this.tabEl.querySelector(`a[href='#${this.options.tabId}${id}']`);

        Tab.getOrCreateInstance(triggerEl).show();

        this.offcanvas.show();
    }
}

export default AsideTab;